import { render, staticRenderFns } from "./cl-tk.vue?vue&type=template&id=7b0f80aa"
import script from "./cl-tk.vue?vue&type=script&lang=js"
export * from "./cl-tk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports